import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function resolveApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  return '/api';
}

axios.defaults.baseURL = resolveApiBaseUrl();

// Attach session JWT (or static API token) to every request.
axios.interceptors.request.use((config) => {
  const next = { ...config };
  next.headers = next.headers || {};
  if (!next.headers.Authorization) {
    const sessionToken = localStorage.getItem('authToken');
    const staticToken = process.env.REACT_APP_API_TOKEN;
    const token = sessionToken || staticToken;
    if (token) {
      next.headers.Authorization = `Bearer ${token}`;
    }
  }
  return next;
});

// On 401 responses clear auth state and redirect to login.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !window.location.pathname.startsWith('/login')
    ) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
